export default {
  namespaced: true,

  getters: {
    getProductIsoCode: (_, __, ___, rootGetters) => id => rootGetters['apis/getObjProp']({ id, key: 'productIsos', prop: 'CodiceIso' }),
  },
}
